export const state = {
  consignees: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/state.js